import { pb } from './pb';

export async function fetchSuppliersPublic(){
  const res = await pb.collection('suppliers').getList(1, 100, {
    filter: 'published = true',
    sort: 'order,name',
  });
  return res.items;
}

export async function fetchSuppliersAdmin(page = 1, perPage = 50){
  return pb.collection('suppliers').getList(page, perPage, {
    sort: 'order,name',
  });
}

export async function createSupplier(data){
  return pb.collection('suppliers').create(data);
}

export async function updateSupplier(id, data){
  return pb.collection('suppliers').update(id, data);
}

export async function deleteSupplier(id){
  return pb.collection('suppliers').delete(id);
}
